import { Navigate } from 'react-router';

import { ANY_SPORT_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { NewSeasonPage } from '@sorare/gameplay/src/components/new-season/NewSeasonPage';

const NewSeason = () => {
  const {
    flags: { use2027LaunchPage = false },
  } = useFeatureFlags();

  if (!use2027LaunchPage) return <Navigate to={ANY_SPORT_MARKET} replace />;

  return <NewSeasonPage />;
};

export default NewSeason;
